<template>
  <md-card>
    <md-card-header>
      <h3>Datos de contacto</h3>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-medium-size-50">
          <md-field :class="validationClass('phone')">
            <label>Teléfono</label>
            <md-input
              data-vv-name="phone"
              v-validate="modelValidations.phone"
              v-model="contactData.phone"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-medium-size-50">
          <md-field :class="validationClass('phoneExt')">
            <label>Ext</label>
            <md-input
              data-vv-name="phoneExt"
              v-validate="modelValidations.phoneExt"
              v-model="contactData.phoneExt"
            ></md-input>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-medium-size-50">
          <md-field :class="validationClass('cellphone')">
            <label>Teléfono Movil</label>
            <md-input
              data-vv-name="cellphone"
              v-validate="modelValidations.cellphone"
              v-model="contactData.cellphone"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-medium-size-50"></div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-medium-size-50">
          <md-field :class="validationClass('alternativeEmail')">
            <label>Correo electrónico alternativo</label>
            <md-input
              data-vv-name="alternativeEmail"
              v-validate="modelValidations.alternativeEmail"
              v-model="contactData.alternativeEmail"
            ></md-input>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <contact-address :address="contactData.address">
          <template slot="header">
            <md-button
              @click="copyAddress"
              class="md-round md-sm"
              v-show="showCopyButton"
              >Copiar direccion fiscal</md-button
            >
          </template>
        </contact-address>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>

import ContactAddress from './Address'
import usesParentValidatorMixin from '@/mixins/usesParentValidator'

const modelValidations = {
  phone: {
  },
  phoneExt: {
  },
  cellphone: {
  },
  address: {
  },
  alternativeEmail: {
    email: true
  }
}

export default {

  name: 'ContactData',

  mixins: [usesParentValidatorMixin],

  components: {
    ContactAddress
  },

  props: {
    contactData: {
      type: Object,
      default: () => { return {} }
    },
    copiableAddress: {
      type: Object,
      // default: () => { return {} }
    },
    showCopyAddress: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showCopyButton() {
      if (!this.showCopyAddress) return false

      return this.copiableAddress &&
        !(Object.keys(this.copiableAddress).length === 0 &&
          this.copiableAddress.constructor === Object)
    }
  },

  mounted() {
    this.watchTouched({ contactData: Object.keys(modelValidations) })
  },
  methods: {
    copyAddress() {
      this.contactData.address = { ...this.copiableAddress.fiscalAddress }
    }
  },

  data() {
    return {
      modelValidations
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Forms/ContactData.vue